module.exports = __webpack_public_path__ + "media/images/icons/payment-methods/diners-85d56d333396cf0c8ce929d6c9b04564.svg";